import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useLocation, useNavigate } from "react-router-dom";
import {
  addDiscount,
  getPropertiesDiscountvalues,
} from "../../../utility/apiServices/userServices";
import * as Yup from "yup";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import Swal from "sweetalert2";
import { formatDate } from "../../userpanel/propertydetail";
import LoaderHome from "../../../components/loader/homeloader";
import { useTranslation } from "react-i18next";


const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(today.getDate() + 1);
const minDate = tomorrow.toISOString().split("T")[0];

const DiscountScreen = () => {
  const { t } = useTranslation()
  const location = useLocation();
  const navigate = useNavigate();
  const id = location?.state?.id;
  const price = location?.state?.price
  const [maxPrice, setMaxPrice] = useState(100)


  const DiscountSchema = Yup.object().shape({
    discountType: Yup.string().required(t("discount_type_required")),
    discountName: Yup.string().required(t("discount_name_required")),
    startDate: Yup.date()
      .required(t("start_date_required"))
      .test(
        "is-before-endDate",
        t("start_date_before_end_date"),
        function (value) {
          const { endDate } = this.parent;
          return endDate ? new Date(value) < new Date(endDate) : true;
        }
      ),
    endDate: Yup.date()
      .required(t("end_date_required"))
      .test(
        "is-after-startDate",
        t("end_date_after_start_date"),
        function (value) {
          const { startDate } = this.parent;
          return startDate ? new Date(value) > new Date(startDate) : true;
        }
      ),
    discount: Yup.number()
      .required(t("discount_required"))
      .min(1, t("discount_min"))
      .test(
        "is-valid-discount",
        t("discount_valid"),
        function (value) {
          const { discountType } = this.parent;
          const maxPrice = this.options.context?.maxPrice || 100;
          if (discountType === "Flat") {
            return value <= maxPrice;
          } else if (discountType === "Percentage") {
            return value <= 90;
          }
          return true;
        }
      ),
  });


  useEffect(() => {
    if (price) {
      setMaxPrice(price)
    }
  }, [price])

  if (!id) {
    navigate("/my-properties");
  }
  const [searchText] = useState("");
  const [discounts, setdiscounts] = useState([]);
  const [dataLoading, setdataLoading] = useState(true);

  useEffect(() => {
    getPropertiesDiscounts(id);
  }, []);
  const getPropertiesDiscounts = async (id) => {
    const response = await getPropertiesDiscountvalues({ propertyId: id });
    console.log("responseresponseresponseresponse :", response);

    if (response?.status) {
      setdiscounts(response?.discounts);
    }
    setdataLoading(false);
  };
  const columns = [
    {
      name: t("discount_type"),
      selector: (row) => row.discount_type,
      sortable: true,
      cell: (row) => <p>{row.discount_type}</p>,
    },
    {
      name: t("discount_name"),
      selector: (row) => row.discount_name,
      sortable: true,
      cell: (row) => <p>{row.discount_name}</p>,
    },
    {
      name: t("start_date"),
      selector: (row) => row.start_date,
      sortable: true,
      cell: (row) => <p>{formatDate(row?.start_date)}</p>,
    },
    {
      name: t("end_date"),
      selector: (row) => row.end_date,
      sortable: true,
      cell: (row) => <p>{formatDate(row?.end_date)}</p>,
    },
    {
      name: t("discount"),
      selector: (row) => row.discount_price,
      sortable: true,
      cell: (row) => {
        return (
          <p style={{}}>
            {row.discount_type === "Flat"
              ? `$${row.discount_price}`
              : `${row.discount_price}%`}
          </p>
        );
      },
    }
  ];


  const handleAddDiscount = async (values, { setSubmitting, resetForm }) => {
    try {
      const data = {
        properties_id: id,
        discount_type: values.discountType,
        start_date: values.startDate,
        end_date: values.endDate,
        discount_price: values.discount,
        discount_name: values.discountName,
      };
      const response = await addDiscount(data);
      if (response?.status) {
        Swal.fire({
          icon: "success",
          text: response?.message,
        });
        getPropertiesDiscounts(id);
        resetForm();
      } else {
        Swal.fire({
          icon: "error",
          text: response?.message,
        });
      }
    } catch (error) {
      console.error("Error adding discount", error);
      Swal.fire({
        icon: "error",
        text: error?.message,
      });
    }
    setSubmitting(false);
  };
  return (
    <React.Fragment>
      <section className="commonpad">
        <Container fluid>
          <Row className="mb-4">
            <Col md={12}>
              <div className="proFlex proFlex1">
              <h2>{t("discount")}</h2>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Formik
                initialValues={{
                  discountType: "",
                  startDate: "",
                  endDate: "",
                  discount: "",
                  discountName: "",
                }}
                validationSchema={DiscountSchema}
                onSubmit={handleAddDiscount}
              >
                {({ isSubmitting, values }) => (
                  <FormikForm className="fieldFlex">
                    <div className="mb-3">
                      <Field
                        as="select"
                        name="discountType"
                        className="form-control"
                      >
                        <option value="">{t("discount_type")}</option>
                        <option value="Flat">{t("flat")}</option>
                        <option value="Percentage">{t("percentage")}</option>
                      </Field>
                      <ErrorMessage
                        name="discountType"
                        component="div"
                        className="errorStyle"
                      />
                    </div>

                    <div className="mb-3">
                      <Field
                        type="text"
                        name="discountName"
                        className="form-control"
                        placeholder={t("discount_name")}
                        style={{ height: "46px" }}
                      />
                      <ErrorMessage
                        name="discountName"
                        component="div"
                        className="errorStyle"
                      />
                    </div>
                    <div className="mb-3">
                      <Field
                        type="date"
                        name="startDate"
                        min={minDate}
                        className="form-control"
                        placeholder="Start Date"
                      />
                      <ErrorMessage
                        name="startDate"
                        component="div"
                        className="errorStyle"
                      />
                    </div>
                    <div className="mb-3">
                      <Field
                        type="date"
                        name="endDate"
                        min={minDate}
                        className="form-control"
                        placeholder="End Date"
                      />
                      <ErrorMessage
                        name="endDate"
                        component="div"
                        className="errorStyle"
                      />
                    </div>
                    <div className="mb-3">
                      <Field
                        type="number"
                        name="discount"
                        min={1}
                        step="0.01"
                        max={values.discountType === "Flat" ? maxPrice : 90}
                        className="form-control"
                        placeholder={t("discount_name")}
                      />

                      <ErrorMessage
                        name="discount"
                        component="div"
                        className="errorStyle"
                      />
                    </div>
                    <Button
                      type="submit"
                      variant="primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? t("adding") : t("add")}
                    </Button>
                  </FormikForm>
                )}
              </Formik>

              {dataLoading ? (
                <>
                  <div className="text-center d-flex justify-content-center">
                    <LoaderHome />
                  </div>
                </>
              ) : (
                <>
                  <div className="hideDesktop">
                    <Row>
                      {discounts?.map((item) => (
                        <Col xs={6} key={item.id}>
                          <div className="discountShadow">
                            {console.log(item, 'This ius  data --')}
                            <h2>{item.discount_type}</h2>
                            <p>
                              {formatDate(item.start_date)} |{" "}
                              {formatDate(item.end_date)}
                            </p>
                            <h3 className="mb-0">{item.discount_price}</h3>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>

                  <div className="hideMobile">
                    <DataTable
                      columns={columns}
                      data={discounts}
                      pagination
                      noHeader
                      responsive
                      className="tableDataTable"
                    />
                  </div>
                </>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default DiscountScreen;
